import http from '@/utils/http'

const sendEmail = ({ email, platformName }) => http()
  .post('/passwords', {
    email,
    resource_type: 'Admin',
    scope: 'admin'
  }, {
    headers: {
      PlatformTokenName: platformName
    }
  })

const reset = ({ token, password, passwordConfirmation, platformName }) => http()
  .put('/passwords', {
    reset_password_token: token,
    password: password,
    password_confirmation: passwordConfirmation,
    resource_type: 'Admin',
    scope: 'admin'
  }, {
    headers: {
      PlatformTokenName: platformName
    }
  })

export default {
  sendEmail,
  reset
}



// WEBPACK FOOTER //
// ./src/api/password.js